import { GetCustomerUsersWithRoleRoutine } from '../redux-routines';

export const initialState = {
  data: [],
  apiKeys: [],
  error: null,
  isFetching: false,
};

export const customerUsersWithRolesReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GetCustomerUsersWithRoleRoutine.REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case GetCustomerUsersWithRoleRoutine.SUCCESS:
      return {
        ...state,
        data: action.payload.users,
        apiKeys: action.payload.apiKeys,
        isFetching: false
      };
    case GetCustomerUsersWithRoleRoutine.FAILURE: {
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };
    }
    default:
      return state;
  }
};
